export const FlagVariants = {
  SQUARE: '1x1',
  WIDE: '3x2'
};

const FLAGS_BASE_URL = 'https://purecatamphetamine.github.io/country-flag-icons';

export const getFlagUrl = (code, variant = FlagVariants.SQUARE) =>
  `${FLAGS_BASE_URL}/${variant}/${encodeURIComponent(String(code).toUpperCase())}.svg`;
